import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_DISCHARGE_LIST } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const dischargeApi = createApi({
    reducerPath: 'dischargeApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/discharge",
    }),
    tagTypes: ["dischargeList"],
    endpoints: (builder) => ({
        getDischargeList: builder.query({
            query: ({ search = "", page = 1, limit = 10, sort = { column: "id", direction: "desc" }, client_type, grade, school }) => ({
                method: "PATCH",
                url: `${MANAGE_DISCHARGE_LIST}`,
                data: { search, page, limit, sort, client_type, grade: grade.value, school: school?.value || null }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["dischargeList"]
        }),
    }),
})

export const {
    useGetDischargeListQuery
} = dischargeApi;